export default "__VITE_ASSET__35ccee23__"